






























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { IDocument } from '@/contract/document.contract';
import { IOci } from '@/contract/oci.contract';
import searchStore from '@/store/modules/search/searchStore';
import masterdataStore from '@/store/modules/masterdata/masterdataStore';
import { Maybe } from '@/shared/BasicTypes';
import SearchResultCard from '@/components/search/SearchResultCard.vue';
import Paginate from '@/components/general/pagination/Paginate.vue';
import { SearchQuery } from '@/model/search-query';
import SearchIcon from '@/assets/img/icons/search.svg';
import FacetSearchDesktop from '../components/search/facetSearch/FacetSearchDesktop.vue';
import FacetSearchMobile from '../components/search/facetSearch/FacetSearchMobile.vue';
import { IFilter, IFilterGroup } from '@/contract/search.contract';
import FilterTagContainer from '../components/search/facetSearch/FilterTagContainer.vue';
import SearchResultDetailsTable from '@/components/search/SearchResultDetailsTable.vue'

@Component({
  components: { SearchResultDetailsTable, FacetSearchDesktop, FacetSearchMobile, FilterTagContainer, SearchResultCard, Paginate, SearchIcon },
})
export default class SearchResults extends Vue {
  public activePage = 1;
  public loading = false;
  public activeDocument: IDocument | null = null;

  private pageSize = 20;

  public created() {
    masterdataStore.dispatch.fetchOcis();
  }

  public get searchResults(): Array<{ document: IDocument; oci: Maybe<IOci> }> {
    const foundDocuments = searchStore.getters.foundDocuments();
    return foundDocuments.map((document) => ({
      document,
      oci: masterdataStore.getters.findOciById(document.ociId),
    }));
  }

  public get totalNrOfPages(): number {
    const totalNrOfResults = this.totalNrOfResults;
    return Math.ceil((totalNrOfResults || 0) / this.pageSize);
  }

  public get totalNrOfResults(): number {
    return searchStore.state.pagedSearchResults?.count || 0;
  }

  public get baseSearchQuery(): SearchQuery {
    return new SearchQuery()
      .withCategory(this.$route.query.r as string, this.$route.query.c as string)
      .withFreeTextSearchTerm(this.$route.query.q as string)
      .withFilters((this.$route.query.f && JSON.parse(this.$route.query.f as string)) || {})
      .withPageSize(this.pageSize);
  }

  public get currentSearchTerm(): string {
    return (
      searchStore.getters.categoryWithTerm(this.baseSearchQuery.category)?.name ||
      this.baseSearchQuery.freeTextSearchTerm ||
      ''
    );
  }

  public get searchQueryHasResults(): boolean {
    return !!searchStore.state.pagedSearchResults && searchStore.state.pagedSearchResults.count > 0;
  }

  public get documentFilters(): IFilterGroup[] {
    return searchStore.state.pagedSearchResults?.filterGroups || [];
  }

  public get activeDocumentFilters(): Array<{ groupId: string; filter: IFilter }> {
    return (
      searchStore.state.pagedSearchResults?.filterGroups.flatMap((fg) =>
        fg.children.filter((f) => f.isSelected).map((f) => ({ groupId: fg.id, filter: f })),
      ) || []
    );
  }

  public onPageChanged(newPage: number) {
    searchStore.dispatch.searchDocuments(this.baseSearchQuery.withPage(newPage));
  }

  public onFilterTermToggled(filterGroup: string, filterTerm: string) {
    const currentFilters = this.baseSearchQuery.filters || {};
    const newFilters = currentFilters;
    if (Object.keys(currentFilters).includes(filterGroup)) {
      if (currentFilters[filterGroup].includes(filterTerm)) {
        newFilters[filterGroup] = currentFilters[filterGroup].filter((f) => f !== filterTerm);
        if (newFilters[filterGroup].length === 0) {
          delete newFilters[filterGroup];
        }
      } else {
        currentFilters[filterGroup].push(filterTerm);
      }
    } else {
      newFilters[filterGroup] = [filterTerm];
    }
    const newQuery = { ...this.$route.query, f: JSON.stringify(newFilters) };

    this.$router.push({
      name: this.Routes.Search,
      query: newQuery,
    });
  }

  public clearAllSearchFilters() {
    this.$router.push({
      name: this.Routes.Search,
      query: { ...this.$route.query, f: '' },
    });
  }

  public showDetails(identifier: string) {
    this.activeDocument = this.searchResults.find(searchResult => searchResult.document.identifier === identifier)?.document || null;
  }

  @Watch('baseSearchQuery', { immediate: true, deep: true })
  public async onSearchQueryChanged() {
    this.loading = true;
    this.activeDocument = null;
    await searchStore.dispatch.searchDocuments(this.baseSearchQuery);
    this.loading = false;
  }
}
